module.exports = __webpack_public_path__ + "static/media/premiere.21ab1cec.png";